// Fallback to copy text (compatible with both HTTP and HTTPS)
function copyToClipboard(text) {
    // Try modern Clipboard API first (HTTPS only)
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
    }

    // Fallback for HTTP: classic method using textarea
    return new Promise((resolve, reject) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
            const successful = document.execCommand('copy');
            document.body.removeChild(textarea);
            if (successful) {
                resolve();
            } else {
                reject(new Error('Copy command failed'));
            }
        } catch (err) {
            document.body.removeChild(textarea);
            reject(err);
        }
    });
}

/* Listener to add close action to the button generated */
function closeListeners() {
    const buttonClose = document.querySelector('#close-cp-modal')
    if (buttonClose) buttonClose.onclick = removeCtModal;
}

/* Append modal to body */
function appendCtModal(cta) {
    if (!cta || document.querySelector('.cp-modal')) return;

    const modal =
        '<div class="cp-modal fade in" id="examplecp-modalLong" tabindex="-1" role="dialog" aria-labelledby="CTA" aria-hidden="false">' +
        '<div class="cp-modal-dialog" role="document">' +
        '<div class="cp-modal-content">' +
        '<div class="cp-modal-header">' +
        '<button type="button" id="close-cp-modal" class="close" data-dismiss="cp-modal" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';
    document.body.insertAdjacentHTML('beforeend', modal);
    const cpModalheader = document.querySelector('.cp-modal-header');
    if (cpModalheader) {
      cpModalheader.insertAdjacentHTML('afterend', '<div class="cp-modal-body">' + cta.outerHTML + '</div>');

      const modalBody = document.querySelector('.cp-modal-body');
      if (modalBody) {
          hydrateLazyImages(modalBody);
      }

      closeListeners();
    }
    document.body.classList.add('cp-modal-open');
}

function removeCtModal() {
    const modal = document.querySelector('.cp-modal');
    if (modal) {
        modal.remove();
        document.body.classList.remove('cp-modal-open');
    }
}

function openCouponWindow(couponid, couponTable = false) {
    const urlParams = new URLSearchParams({
        cp: 1,
        cta: couponid,
    });
    if (couponTable) urlParams.append('couponTable', 1);
    window.open(`${window.location.protocol}//${window.location.host}${window.location.pathname}?${urlParams.toString()}`);
}
function handleBonusCodeClick(bonusCodeCta) {
    const theBonusCodeCta = bonusCodeCta.currentTarget;
    const value = theBonusCodeCta.querySelector('[class*="value"] span');
    if (!value) return;

    const { copiedtext, visit, promocode } = value.dataset;
    const isCouponTable = theBonusCodeCta.closest('.coupons-table') !== null;

    if (theBonusCodeCta.dataset.url && !theBonusCodeCta.classList.contains('has-code') && !theBonusCodeCta.dataset.cpcopy) {
        openCouponWindow(theBonusCodeCta.dataset.couponid, isCouponTable);
        window.location.href = theBonusCodeCta.dataset.url;
    } else {
        copyToClipboard(promocode).then(() => {
            document.querySelectorAll(`.${theBonusCodeCta.classList[0]}`).forEach((bonusCodeCtaCopied) => {
                const button = bonusCodeCtaCopied.querySelector('[class*="button"]');
                button.innerHTML = copiedtext;
                bonusCodeCtaCopied.classList.add('copied');
            });
            const btnElement = theBonusCodeCta.parentElement.querySelector('.btn');
            if (btnElement && btnElement.dataset.target) {
                delete btnElement.dataset.target;
            }
        }).catch((err) => {
            console.error('Failed to copy text:', err);
        });
        if (!theBonusCodeCta.classList.contains('has-code') && theBonusCodeCta.dataset.cpcopy) {
            setTimeout(() => {
                document.querySelectorAll(`.${theBonusCodeCta.classList[0]}`).forEach((bonusCodeCtaCopied) => {
                    bonusCodeCtaCopied.querySelector('[class*="button"]').innerHTML = visit;
                    bonusCodeCtaCopied.classList.add('visit');
                });
            }, 2000);
        }
        if (theBonusCodeCta.classList.contains('visit')) {
            window.location.href = theBonusCodeCta.dataset.url;
        }
    }
}
function handleCtaButtonClick(CtaButton) {
    const theCtaButton = CtaButton.currentTarget;
    const isCouponTable = theCtaButton.closest('.coupons-table') !== null;

    if (theCtaButton.dataset.url) {
        openCouponWindow(theCtaButton.dataset.couponid, isCouponTable);
        window.location.href = theCtaButton.dataset.url;
    } else {
        const buttonCta = CtaButton.target.parentElement;
        if (buttonCta.dataset.cpcopy) {
            copyToClipboard(buttonCta.dataset.promocode).catch((err) => {
                console.error('Failed to copy text:', err);
            });
        } else if (theCtaButton.parentElement.dataset.showcopy) {
            if (theCtaButton.parentElement.dataset.promocode) {
                copyToClipboard(theCtaButton.parentElement.dataset.promocode).catch((err) => {
                    console.error('Failed to copy text:', err);
                });
            }
            openCouponWindow(theCtaButton.parentElement.parentElement.dataset.coupon, isCouponTable);
            window.location.href = decodeURIComponent(window.atob(theCtaButton.dataset.link));
        }
    }
}
function handleCtaButtonCopyClick(CtaButtonCopy) {
    const parentElement = CtaButtonCopy.currentTarget.parentElement;
    if (!parentElement.classList.contains('clicked')) {
        copyToClipboard(parentElement.dataset.promocode).then(() => {
            const btn = parentElement.querySelector('.btn');
            parentElement.classList.add('changing');
            btn.innerHTML = parentElement.dataset.copiedtext;
            setTimeout(() => {
                parentElement.classList.remove('changing');
                parentElement.classList.add('clicked');
                btn.innerHTML = parentElement.dataset.visit;
            }, 2000);
        }).catch((err) => {
            console.error('Failed to copy text:', err);
        });
    }
}
function removeEventListeners(selector, eventType, handler) {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => {
        element.removeEventListener(eventType, handler);
    });
}
function addEventListeners(selector, eventType, handler) {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => {
        element.addEventListener(eventType, handler);
    });
}
function handleClick() {
    setTimeout(() => {
        // Find all elements with bonus-code, container classes and extract all unique prefixes
        const allElements = document.querySelectorAll('[class*="-bonus-code"], [class*="-container"]');
        const prefixes = new Set();

        allElements.forEach(element => {
            const classes = element.className.split(' ');
            classes.forEach(cls => {
                // Extract prefix from classes like "nsn_coupon_123-bonus-code" or "nsn_coupon_123-container"
                const match = cls.match(/^(.+?)-(bonus-code|container)/);
                if (match) {
                    prefixes.add(match[1]);
                }
            });
        });

        // Add event listeners for each prefix found
        prefixes.forEach(prefix => {
            removeEventListeners(`.${prefix}-bonus-code`, 'click', handleBonusCodeClick);
            removeEventListeners(`.${prefix}-container .btn`, 'click', handleCtaButtonClick);
            removeEventListeners(`.${prefix}-container .container-btn-col`, 'click', handleCtaButtonCopyClick);
            addEventListeners(`.${prefix}-bonus-code`, 'click', handleBonusCodeClick);
            addEventListeners(`.${prefix}-container .btn`, 'click', handleCtaButtonClick);
            addEventListeners(`.${prefix}-container .container-btn-col`, 'click', handleCtaButtonCopyClick);
        });
    }, 100);
}

function addEventListenersCouponsTable(coupon) {
    coupon.querySelectorAll('[class*="bonus-code"]').forEach((el) => el.addEventListener('click', handleBonusCodeClick));
    coupon.querySelectorAll('.btn').forEach((el) => el.addEventListener('click', handleCtaButtonClick));
    coupon.querySelectorAll('[class*="container-btn-col"]').forEach((el) => el.addEventListener('click', handleCtaButtonCopyClick));
}

function triggerLoadMoreIfCouponTable() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('couponTable') === '1') {
        triggerLoadMoreCoupons();
    }
}

function triggerLoadMoreCoupons() {
    if (window.triggeredLoadMore) return;
    window.triggeredLoadMore = true;

    const couponsTable = document.querySelector('.coupons-table');
    const loadMoreBtn = couponsTable.querySelector('.load-more-coupons');
    if (loadMoreBtn) {
        setTimeout(() => loadMoreBtn.click(), 0);
    }
}

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.matches('[id*="cta-"]')) {
                addEventListenersCouponsTable(node);
            }
        });
    });
});
const couponsTable = document.querySelector('.coupons-table');
if (couponsTable) {
    observer.observe(document.querySelector('.coupons-table'), { childList: true, subtree: true });
}
const modalObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.classList.contains('cp-modal')) {
                const coupons = node.querySelectorAll('[id*="cta-"]');
                coupons.forEach((coupon) => {
                    addEventListenersCouponsTable(coupon);
                });
            }
        });
    });
});

modalObserver.observe(document.body, { childList: true, subtree: true });

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        handleClick();
        triggerLoadMoreIfCouponTable();
        initializeGeneralFeatures();
    });
} else {
    handleClick();
    triggerLoadMoreIfCouponTable();
    initializeGeneralFeatures();
}
window.onpageshow = function (event) {
    if (event.persisted) {
        handleClick();
        triggerLoadMoreIfCouponTable();
    }
};

function initializeGeneralFeatures() {
    /* Get page parameters */
    const getUrlParam = (param) => new URLSearchParams(window.location.search).get(param);

    /* Helper function to get the absolute position */
    const getOffsetTop = element => {
        let offsetTop = 0;
        while(element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }
        return offsetTop;
    }

    /* Display cta zone in modal if called by url */
    let current_cta = getUrlParam('cta');
    if (current_cta) {
        const cta = document.querySelector('#cta-' + current_cta);
        if (cta) {
            appendCtModal(cta);
        }
    }

    let coupon_copied = getUrlParam('cpid');
    if (coupon_copied) {
        const coupon = document.querySelector('#cta-' + coupon_copied);
        if (coupon) {
            const couponBonusCode = coupon.querySelector('[class*="bonus-code"]');
            const value = couponBonusCode.querySelector('[class*="value"] span');
            const valueCopied = value.dataset.copiedtext;
            const button = couponBonusCode.querySelector('[class*="button"]');
            button.innerHTML = valueCopied;
            couponBonusCode.classList.add('copied');
        }
    }

    /* --------- Bonus code sticky --------- */
    const bookmakerCta = document.querySelector('div[data-coupon][data-sticky]:not(.lightmode)');

    if (bookmakerCta) {
        if (screen.width < 767) {
            const bookmakerCtaHeight = bookmakerCta.offsetHeight;
            bookmakerCta.style.height = bookmakerCtaHeight + 'px';
            let initialScrollEvent = true;
            let couponStickyBottom = '0px';

            // Store the original offset position before the element becomes sticky
            const originalOffsetTop = getOffsetTop(bookmakerCta);
            const stickyTriggerPoint = originalOffsetTop + bookmakerCta.offsetHeight;

            let observer = new MutationObserver(function (m) {
                if (m[0].addedNodes[0]) {
                    if (m[0].addedNodes[0].nodeName === 'DIV') {
                        const bodyElements = document.querySelectorAll('body > *');

                        bodyElements.forEach((bodyElement) => {
                            const bodyElementStyles = window.getComputedStyle(bodyElement);

                            if (
                                bodyElementStyles.getPropertyValue('position') == 'fixed' &&
                                bodyElementStyles.getPropertyValue('bottom') == '0px' &&
                                bodyElementStyles.getPropertyValue('display') != 'none' &&
                                bodyElementStyles.getPropertyValue('visibility') != 'hidden' &&
                                bodyElementStyles.getPropertyValue('opacity') != '0' &&
                                !bodyElement.classList.contains('cp-modal') &&
                                bodyElement instanceof HTMLElement
                            ) {
                                setTimeout(() => {
                                    if (bodyElementStyles.getPropertyValue('height') > couponStickyBottom) {
                                        couponStickyBottom = bodyElementStyles.getPropertyValue('height');
                                    }
                                }, 500);
                            }
                        });
                    }
                }
            });

            observer.observe(document.body, { childList: true });

            window.addEventListener('scroll', function () {
                if (!initialScrollEvent) {
                    const bookmakerCtaRow = bookmakerCta.querySelector('[class$="row"]');

                    if (window.scrollY >= stickyTriggerPoint) {
                        bookmakerCta.classList.add('sticky');
                        bookmakerCtaRow.style.bottom = couponStickyBottom;
                    } else {
                        bookmakerCta.classList.remove('sticky');
                        bookmakerCtaRow.style.bottom = '0px';
                    }
                }
                initialScrollEvent = false;
            });
            if (window.scrollY >= stickyTriggerPoint) {
                const bookmakerCtaRow = bookmakerCta.querySelector('[class$="row"]');
                bookmakerCta.classList.add('sticky');
                bookmakerCtaRow.style.bottom = couponStickyBottom;
            } else {
                const bookmakerCtaRow = bookmakerCta.querySelector('[class$="row"]');
                bookmakerCta.classList.remove('sticky');
                bookmakerCtaRow.style.bottom = '0px';
            }
        }
        window.addEventListener('resize', function () {
            if (screen.width > 767 && bookmakerCta) {
                bookmakerCta.classList.remove('sticky');
            }
        });
    }

    /*
    * text mode script
    */
    document.querySelectorAll('.textmode').forEach((element) => {
        element.addEventListener('click', function () {
            if (!this.dataset.clicked) {
                const elementWidth = this.offsetWidth + 'px';

                this.style.width = elementWidth;
                const textArea = document.createElement('textarea');
                textArea.value = this.textContent.trim();
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);

                this.classList.add('clicked');
                this.textContent = this.dataset.copy;
                this.dataset.clicked = 'true';

                setTimeout(() => {
                    this.textContent = this.dataset.visit;
                }, 1000);
            } else {
                const url = decodeURIComponent(escape(atob(this.dataset.url)));
                if (this.dataset.target === '0') {
                    window.open(url, '_blank');
                } else {
                    window.location.href = url;
                }
            }
        });
    });
}

// Obfuscated links (works for initial DOM + AJAX injected content)
document.addEventListener('click', function (e) {
    const el = e.target.closest('.nsn-obf-link');
    if (!el) return;

    e.preventDefault();

    const b64 = el.getAttribute('data-link');
    if (!b64) return;

    let url = '';
    try {
        url = decodeURIComponent(escape(atob(b64)));
    } catch (err) {
        try {
            url = atob(b64);
        } catch (err2) {
            return;
        }
    }

    const target = el.getAttribute('data-target') || '_self';

    // only allow http(s) to avoid weird payloads
    if (!/^https?:\/\//i.test(url)) return;

    if (target === '_blank') {
        window.open(url, '_blank');
    } else {
        window.location.href = url;
    }
}, true);

function hydrateLazyImages(scope = document) {
    scope.querySelectorAll('img.lazy[data-src]').forEach((img) => {
        if (
            !img.getAttribute('src') ||
            img.getAttribute('src').startsWith('data:image/')
        ) {
            img.setAttribute('src', img.dataset.src);
        }

        img.classList.remove('lazy');
        img.classList.add('loaded');
        img.dataset.llStatus = 'loaded';
    });
}
